import { render, staticRenderFns } from "./PeriodPricing.vue?vue&type=template&id=97a0d1ea"
import script from "./PeriodPricing.vue?vue&type=script&lang=js"
export * from "./PeriodPricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports